import { generateUtilityClass } from "../generateUtilityClass/index.es.js";
import { generateUtilityClasses } from "../generateUtilityClasses/index.es.js";
const COMPONENT_NAME = "Popper";
function getPopperUtilityClass(slot) {
  return generateUtilityClass(COMPONENT_NAME, slot);
}
generateUtilityClasses(COMPONENT_NAME, ["root"]);
export {
  getPopperUtilityClass
};
//# sourceMappingURL=popperClasses.es.js.map
